import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, debounce } from '@mui/material';
import { getSettlementList } from 'redux/actions/SettlementAction';
import CommonSubHeader from 'components/commonSubHeader/CommonSubHeader';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import { getDateFormat, handlePermissions } from 'utils/utils';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';

const Payment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {state} = useLocation();
  const pageNavigation = () => {
    navigate('/payment/newPayment');
  };
  
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const filterPage = searchParams?.get('page');
  const filterRowPerPage = searchParams?.get('rowPerPage');
  const filterSearch = searchParams?.get('search');
  const [page, setPage] = useState(filterPage ? parseInt(filterPage) : 0);
  const [rowsPerPage, setRowsPerPage] = useState(filterRowPerPage ? filterRowPerPage : 10);
  const [status, setStatus] = useState('all');
  const [search, setSearch] = useState(filterSearch ? filterSearch : '');
  const [dateFrom, setDateFrom] = useState((startDate && startDate !== 'null') ? startDate : startDate === 'null' ? '' : state?.fromTab ? state?.dateFrom:
    getDateFormat(new Date(), "reservationDateFormat")
  );
  const [dateTo, setDateTo] = useState((endDate && endDate !== 'null') ? endDate : endDate === 'null' ? '' : state?.fromTab ? state?.dateTo:
    getDateFormat(new Date(), "reservationDateFormat")
  );
  const paymentData = useSelector(
    (state) => state?.getSettlementList?.settlementList?.data
  );

  const paymentLoader = useSelector(
    (state) => state?.getSettlementList?.loading
  );

  let paramsList = {};
  searchParams.forEach((value, key) => {
    paramsList[key] = value;
  });

  let filterData = {
    page: page,
    dateFrom: dateFrom ? dateFrom : '',
    dateTo: dateTo ? dateTo : '',
    status: '',
    pageSize: rowsPerPage ? rowsPerPage : '',
    search: search ? search : '',
  };

  useEffect(() => {
    dispatch(getSettlementList(filterData));
  }, []);

  const onSearchQuery = debounce((e) => {
    setSearchParams({...paramsList, page:0, search:e})
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
      pageSize: '',
    };
    dispatch(getSettlementList(searchFilterData));
  }, 1000);

  const onSelectDateRange = (newValue) => {
    if (newValue === null || newValue === 0) {
      setSearchParams({...paramsList, startDate: 'null', endDate: 'null'})
      setDateFrom('');
      setDateTo('');
      filterData = { ...filterData, dateFrom: '', dateTo: '' };
    } else {
      setSearchParams({...paramsList, startDate:getDateFormat(newValue[0], 'reservationDateFormat'), endDate:getDateFormat(newValue[1], 'reservationDateFormat')})
      setDateFrom(getDateFormat(newValue[0],'reservationDateFormat'));
      setDateTo(getDateFormat(newValue[1],'reservationDateFormat'));
      filterData = {
        ...filterData,
        dateFrom: getDateFormat(newValue[0],"reservationDateFormat"),
        dateTo: getDateFormat(newValue[1],"reservationDateFormat"),
      };
    }
    dispatch(getSettlementList(filterData));
  };

  const handleChangePage = (event, newPage) => {
    setSearchParams({...paramsList, page:newPage})
    setPage(newPage);
    dispatch(getSettlementList({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setSearchParams({...paramsList, rowPerPage:parseInt(event.target.value), page:0})
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getSettlementList({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const tableOnClickRow = (navigate, val) => {
    navigate(`/payment/paymentdetails`, {
      state: { id: val.id, name: val.name, paymentMode:val?.modeOfPayment },
    });
  };

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const settlementRoleEnum = roleAndPermissionEnum.settlement

  const accessForall = handlePermissions(roleAndPermissions, settlementRoleEnum.moduleKey, {defaultAllAccess: settlementRoleEnum.all, customAccess: settlementRoleEnum.add});

  const accessForOnlyView = handlePermissions(roleAndPermissions, settlementRoleEnum.moduleKey, {customAccess: settlementRoleEnum.view});

  const accessForAdd = handlePermissions(roleAndPermissions, settlementRoleEnum.moduleKey, {customAccess: settlementRoleEnum.add});

  const addAccess = (accessForall||accessForAdd)

  return (
    <Box>
      <CommonSubHeader
        buttonName={addAccess && 'New Payment'}
        onSelectDateRange={onSelectDateRange}
        onSearchQuery={onSearchQuery}
        dateFrom={dateFrom}
        dateTo={dateTo}
        navigation={pageNavigation}
      />
      {paymentLoader ? (
        <Loader />
      ) : (
        <CommonTable
          data={paymentData}
          page={page}
          rowsPerPage={rowsPerPage}
          onSearchQuery={onSearchQuery}
          tableOnClickRow={tableOnClickRow}
          isClickable={true}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </Box>
  );
};

export default Payment;
